import React, { Component } from 'react'
import InputText from '../../../components/inputs/InputText'
import moment from 'moment'
import DatePicker from '../../../components/datePicker/DatePicker'
import { validate } from '../../../utils/validation/CommonValidator'
import { ErrorMessage } from '../../../utils/Messages'
import SwalServices from '../../../services/swalServices/SwalServices'
import { isValidForm } from '../../../utils/validation/CommonValidator'
import { CommonValidationMessages } from '../../../utils/Messages'
import TextInput from '../../../components/UIComponent/TextInput'
import { APIURL } from '../../../services/axiosServices/ApiEndPoints'
import IndividualMemberService from '../../../services/axiosServices/apiServices/IndividualMemberService'
import { checkParameters } from '../../../utils/Encryption'
import { GetImage as getImage } from '../../../services/axiosServices/ApiEndPoints'
import { Navigate } from 'react-router-dom'
import { encryptAES } from '../../../utils/Encryption'




export default class ViewResponse extends Component {
    constructor(props) {
        super(props);
        this.individualMemberService = new IndividualMemberService()
    
        this.swalServices = new SwalServices();
        this.state = {
        //   postingDetails: {},
        //   collaborationPortalPostingId: 0,
        //   contactInfoId: 0,
        //   totalResultes: 0,
        //   isLoading: false,
        //   collaborationResponsesList: [],
        //   pagination: {
        //     pageNo: 1,
        //     pageSize: 10,
        //     collaborationPortalPostingId: 0,
        //   },
        //   isEditable: false,
          
      collaborationPortalPostingId: 0,
      contactInfoId: 0,
      recieverCompanyDetails: [],
      documentList: [],
      isRespondBtnLoading:false,
      senderCompanyDetails: {
        to: "",
        senderName: "",
        senderCompanyName: "",
        senderContactNumber: "",
        senderEmail: "",
        senderMessage: "",
      },
          validationRule: {
            senderMessage: [
                {
                  type: "require",
                  message: CommonValidationMessages.FieldRequired.replace(
                    "{0}",
                    "Message"
                  ),
                },
              ],
              senderName: [
                {
                  type: "require",
                  message:CommonValidationMessages.FieldRequired.replace(
                    "{0}",
                    "Sender Name"
                  ),
                },
              ],
              senderCompanyName: [
                {
                  type: "require",
                  message: CommonValidationMessages.FieldRequired.replace(
                    "{0}",
                    "Company Name"
                  ),
                },
              ],
              senderContactNumber: [
                {
                  type: "require",
                  message: CommonValidationMessages.FieldRequired.replace(
                    "{0}",
                    "Contact Number"
                  ),
                },
              ],
              senderEmail: [
                {
                  type: "require",
                  message: CommonValidationMessages.FieldRequired.replace(
                    "{0}",
                    "email address"
                  ),
                },
                {
                  type: "email",
                  message: CommonValidationMessages.FieldRequired.replace(
                    "{0}",
                    "valid email address"
                  ),
                },
              ],
          },
          validState: {
            isValid: true,
            error: {},
          },
        };
      }

      
  getAllCollaborationResponsesList = (id) => {
    if (id > 0) {
      let req = { ...this.state.pagination };
      req.collaborationPortalPostingId =
        this.state.collaborationPortalPostingId;

      this.individualMemberService
        .getAllCollaborationResponsesList(req)
        .then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            const itemList = response.responseItem.responseContent?.itemList;

            if (Array.isArray(itemList)) {
              const collaborationPostResponseId =
                this.state.collaborationPostResponseId;
              const matchedItem = itemList.find(
                (item) =>
                  item.collaborationPostResponseId ===
                  collaborationPostResponseId
              );

              if (matchedItem) {
                let senderDetails = { ...this.state.senderCompanyDetails };
                senderDetails.senderEmail = matchedItem.senderEmail;
                senderDetails.senderMessage = matchedItem.senderMessage;
                senderDetails.senderName = matchedItem.senderName;
                senderDetails.senderCompanyName = matchedItem.senderCompanyName;
                senderDetails.senderContactNumber =
                  matchedItem.senderContactNumber;
                this.setState({ senderCompanyDetails: { ...senderDetails } });
              } else {
                this.swalServices.Error("No matching response found.");
              }
            } else {
              this.swalServices.Error("Invalid data format.");
            }
          } else {
            this.swalServices.Error(response.message);
          }
        });
    }
  };
    
      componentDidMount() {
        let params = window.location.href;
        let array = params.split('/');
        let postingId = array[4];
        let collaborationPostResponseId = array[5];

        if (postingId && (postingId = checkParameters(postingId, "Number")) && (collaborationPostResponseId = checkParameters(collaborationPostResponseId, "Number"))) {

          this.setState({collaborationPostResponseId : collaborationPostResponseId, collaborationPortalPostingId : postingId},()=>{
                this.getPostingDetailsbyId(postingId);
                // this.getIndividualProfileDetails(postingId)
                this.getAllCollaborationResponsesList(postingId)
                this.getPostDocumentsById(postingId)
          })
        }
      }
    
    getPostingDetailsbyId = (id) => {
        this.individualMemberService
          .getPostingDetailsbyId(id)
          .then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
              if (response.responseItem.responseContent != null) {
                const documentArray = response.responseItem.responseContent
                  .supportingDocumentPath
                  ? response.responseItem.responseContent.supportingDocumentPath
                      .split(",")
                      .map((x) => x.trim())
                  : [];
    
                this.setState({
                  recieverCompanyDetails: response.responseItem.responseContent,
                });
              } else {
                this.swalServices.Error("something went wrong");
              }
            } else {
              this.SwalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });
      };


      getPostDocumentsById = (id) => {
        if (id > 0) {
          this.individualMemberService.getPostDocumentsById(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
              this.setState({
                documentList: response.responseItem.responseContent,
              });
            } else {
              this.swalServices.Error(response.message);
            }
          });
        }
      };
      
     

      handleChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        let details = this.state.senderCompanyDetails;
        details[name] = value;
        this.setState({ senderCompanyDetails: { ...details } });
      }
      isValidateAllFields = () => {
        const returnValidState = isValidForm(
          this.state.senderCompanyDetails,
          this.state.validationRule,
          this.state.validState
        );
        this.setState({ validState: returnValidState });
        return returnValidState.isValid;
      };
    
      validateField = (key) => {
        const returnValidState = validate(
          key,
          this.state.senderCompanyDetails,
          this.state.validationRule,
          this.state.validState
        );
        this.setState({
          validState: returnValidState,
        });
      };

      addCollaborationPost = () => {
        let req = {};
        req.collaborationPortalPostingId =
          this.state.collaborationPortalPostingId ?? 0;
        req.senderContactNumber =
          this.state.senderCompanyDetails.senderContactNumber ?? "";
        req.senderCompanyName =
          this.state.senderCompanyDetails.senderCompanyName ?? "";
        req.senderName = this.state.senderCompanyDetails.senderName ?? "";
        req.senderMessage = this.state.senderCompanyDetails.senderMessage ?? "";
        req.senderContactInfoId = this.state.contactInfoId ?? "";
        req.senderEmail = this.state.senderCompanyDetails.senderEmail ?? "";
    
    
        this.setState({ isRespondBtnLoading: true }, () => {
          let isValidAll = this.isValidateAllFields();
        
          if (isValidAll) {
            this.individualMemberService
              .addCollaborationPost(req)
              .then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                  this.swalServices.Success("Response has been sent Successfully!");
                  // Navigate(Routes.AvailableCollaborations);
                } else {
                  this.swalServices.Error(response.message);
                }
        
                this.setState({ isRespondBtnLoading: false });
              });
          } else {
            this.setState({ isRespondBtnLoading: false });
          }
        });
        
    
      };

      
    back = () => {
      this.setState({  route: "/ManagePosting?collaborationPortalPostingId=" + encryptAES(this.state.collaborationPortalPostingId) });
    }
      
  render() {
    if (this.state.route != null) {
          return <Navigate to={this.state.route} />;
        }
    return (
       <>
        <div className="main-body-section">
        <main className="pb-10">
          <div className="custom-card shadow-lg mb-4 rounded-md">
            <div className="main-sub-title">Collaboration Details</div>

            <div className="w-full ">
              <div className="border-card">
                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Company Name:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      name="companyName"
                      className="w-full"
                      value={this.state.recieverCompanyDetails.companyName}
                      identity="Posting_Detail"
                      handleChange={(e) => this.handleChange(e)}
                      disabled={true}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>
                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Title :<span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      placeholder=""
                      type="text"
                      name="title"
                      value={this.state.recieverCompanyDetails.title}
                      identity="Posting_Detail"
                      handleChange={(e) => this.handleChange(e)}
                      //   onBlur={(e) => props.ValidateAdminDetails("name")}
                      disabled={true}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12  mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Description:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <textarea
                      className="w-full h-[120px]"
                      placeholder=""
                      rows="2"
                      value={this.state.recieverCompanyDetails.description}
                      name="description"
                      onChange={(e) => this.handleChange(e)}
                      disabled={true}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

               

                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Deadline:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <input
                      id="default"
                      placeholder=""
                      type="date"
                      name="deadlineDate"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      value={moment(
                        this.state.recieverCompanyDetails.deadlineDate
                      ).format("YYYY-MM-DD")}
                      onChange={(e) => this.handleChange(e)}
                      //   onBlur={(e) => props.ValidateAdminDetails("name")}
                      disabled={true}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Posted On:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <input
                      id="default"
                      placeholder=""
                      type="date"
                      name="postedOn"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      value={moment(this.state.recieverCompanyDetails.postedOn).format(
                        "YYYY-MM-DD"
                      )}
                      onChange={(e) => this.handleChange(e)}
                      //   onBlur={(e) => props.ValidateAdminDetails("name")}
                      disabled={true}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Posted By:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      placeholder=""
                      type="text"
                      name="name"
                      value={this.state.recieverCompanyDetails.name}
                      identity="Posting_Detail"
                      handleChange={(e) => this.handleChange(e)}
                      disabled={true}
                      //   onBlur={(e) => props.ValidateAdminDetails("name")}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Supported Documents:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                    <div className="col-span-9 membership-searchbar">
                        {Array.isArray(this.state.documentList) &&
                                         this.state.documentList.length > 0 && (
                                           <ul>
                                             {this.state.documentList.map((file, index) => {
                                               const fileName = file.documentPath;
                                               const isSaved =
                                                 file.collaborationPortalDocumentMappingId > 0;
                                               const key = isSaved
                                                 ? `db-${file.collaborationPortalDocumentMappingId}`
                                                 : `new-${file.tempKey}`;
                                               const lowerFile = fileName.toLowerCase();
                   
                                               const isPDF = lowerFile.endsWith(".pdf");
                                               const isImage =
                                                 lowerFile.endsWith(".jpg") ||
                                                 lowerFile.endsWith(".jpeg") ||
                                                 lowerFile.endsWith(".png");
                                               const isWord =
                                                 lowerFile.endsWith(".doc") ||
                                                 lowerFile.endsWith(".docx");
                                               const isExcel =
                                                 lowerFile.endsWith(".xls") ||
                                                 lowerFile.endsWith(".xlsx");
                   
                                               const openOfficeViewer = (fileName, type) => {
                                                 const url = `${APIURL}Common/getFile?type=${type}&fileName=${encodeURIComponent(
                                                   fileName
                                                 )}`;
                                                 window.open(url, "_blank");
                                               };
                   
                                               return (
                                                 <li
                                                   key={key}
                                                   className="text-[#757575] flex items-center gap-2 mb-2"
                                                 >
                                                   {isPDF ? (
                                                     <a
                                                       href={`${APIURL}Common/GetPDF?type=CollaborationPublishPostDocuments&&fileName=${encodeURIComponent(
                                                         fileName
                                                       )}`}
                                                       target="_blank"
                                                       rel="noopener noreferrer"
                                                       className="text-red-400 common-fonts-size mobile-14"
                                                     >
                                                       {fileName}
                                                     </a>
                                                   ) : isImage ? (
                                                     <a
                                                       href={`${APIURL}${getImage}?type=CollaborationPublishPostDocuments&&fileName=${encodeURIComponent(
                                                         fileName
                                                       )}`}
                                                       target="_blank"
                                                       rel="noopener noreferrer"
                                                       className="text-red-400 common-fonts-size mobile-14"
                                                     >
                                                       {fileName}
                                                     </a>
                                                   ) : isWord || isExcel ? (
                                                     <button
                                                       type="button"
                                                       onClick={() =>
                                                         openOfficeViewer(
                                                           fileName,
                                                           "CollaborationPublishPostDocuments"
                                                         )
                                                       }
                                                       className="text-red-400 common-fonts-size mobile-14"
                                                     >
                                                       {fileName}
                                                     </button>
                                                   ) : (
                                                     <span>{fileName}</span>
                                                   )}
                   
                                                 
                                                 </li>
                                               );
                                             })}
                                           </ul>
                                         )}
                    </div>
                  </div>

                  <div className="text-sm text-gray-500 mt-1 italic">
                    Supported file types: PDF, Word (.doc, .docx), Excel (.xls, .xlsx), JPEG, PNG
                  </div>
            
              </div>
            </div>
          </div>

          <div className="custom-card shadow-lg mb-4 rounded-md">
            <div className="w-full ">
              <div className="border-card">
                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    To:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      name="to"
                      className="w-full"
                      value={this.state.recieverCompanyDetails.companyName}
                      identity="Employee"
                      handleChange={(e) => this.handleChange(e)}
                      disabled={true}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12  mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Message:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <textarea
                      className="w-full h-[120px]"
                      placeholder=""
                      rows="2"
                      value={this.state.senderCompanyDetails.senderMessage}
                      name="senderMessage"
                      onChange={(e) => this.handleChange(e)}
                      onBlur={() => this.validateField("senderMessage")}
                      disabled = {true}
                    />
                  </div>
                  {/* <ValidationText
                        error={this.state.validState.error.senderMessage}
                      />  */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Sender Name :<span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      placeholder=""
                      type="text"
                      name="senderName"
                      value={this.state.senderCompanyDetails.senderName}
                      identity="senderName"
                      handleChange={(e) => this.handleChange(e)}
                      //   onBlur={(e) => props.ValidateAdminDetails("name")}
                      validateField={() => this.validateField("senderName")}
                      disabled={true}
                    />
                  </div>
                   {/* <ValidationText
                        error={this.state.validState.error.senderName}
                      />  */}
                </div>


                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Sender Company :<span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      placeholder=""
                      type="text"
                      name="senderCompanyName"
                      value={this.state.senderCompanyDetails.senderCompanyName}
                      identity="senderCompanyName"
                      handleChange={(e) => this.handleChange(e)}
                      //   onBlur={(e) => props.ValidateAdminDetails("name")}
                      disabled={true}
                      validateField={() =>
                        this.validateField("senderCompanyName")
                      }
                    />
                  </div>
                   {/* <ValidationText
                        error={this.state.validState.error.senderCompanyName}
                      />  */}
                </div>
                

                
                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Sender Contact Number :<span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      placeholder=""
                      type="number"
                      name="senderContactNumber"
                      value={this.state.senderCompanyDetails.senderContactNumber}
                      disabled = {true}
                      identity="senderContactNumber"
                      handleChange={(e) => this.handleChange(e)}
                      //   onBlur={(e) => props.ValidateAdminDetails("name")}
                      validateField={() =>
                        this.validateField("senderContactNumber")
                      }
                    />
                  </div>
                  {/* <ValidationText
                        error={this.state.validState.error.senderContactNumber}
                      />  */}
                </div>


                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Sender Email :<span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      placeholder=""
                      type="text"
                      name="senderEmail"
                      value={this.state.senderCompanyDetails.senderEmail}
                      disabled = {true}
                      identity="senderEmail"
                      handleChange={(e) => this.handleChange(e)}
                      validateField={() =>
                        this.validateField("senderEmail")
                      }
                      //   onBlur={(e) => props.ValidateAdminDetails("name")}
                    />
                  </div>
                   {/* <ValidationText
                        error={this.state.validState.error.senderEmail}
                      />  */}
                </div>
              <div className="col-span-12">
             
              </div>
              </div>
            </div>
          </div>
          </main>
          <div className="flex flex-wrap justify-between space-x-10 mt-12">
          <div>
            <button className="w-32 px-7 py-2 btn-sm btn-gray text-lg text-white" onClick={() => this.back()}>
              Back
            </button>
          </div>
       
        </div>
          </div>

      </>
    )
  }
}
